<template>
       
    <div class="flex justify-between">

        <div class="h-screen sm:w-2/5 sm:px-10 lg:px-20 sm:pt-10 pb-20 xl:pt-20 text-white hidden sm:block -mx-4 sm:-mx-6 lg:-mx-12 xl:-mx-24" style="background-image: url('/img/background-tall.svg')">
            <div class="text-4xl font-semibold leading-snug" v-html="leftHeading"></div>
            <div class="pt-8" v-html="leftSubText"></div>

            <div class="sm:text-xl lg:text-2xl font-semibold pt-20 pb-4" v-html="leftHeading2"></div>
            <div class="flex pb-2" v-for="(text, i) in leftTicks" :key="i">
                <img class="pr-2" src="/img/icon/tick.svg"> <span>{{ text }}</span>
            </div>            
        </div>
        
        <div class="w-3/4 sm:w-2/5 lg:w-1/3 mx-auto pt-10 sm:py-20">

            <!--div class="text-lg_ alert-box alert-error text-center mx-auto py-6">                       
                Innlogging vil være utilgjengelig i perioder torsdag 4. januar mellom kl 21 og midnatt grunnet vedlikehold
            </div-->            

            <div class="alert-box alert-error" v-if="errorMsg" v-html="errorMsg"></div>
            <div class="alert-box alert-success" v-if="successMsg" v-html="successMsg"></div>

            <h1 v-if="forgotPasswordMode">Glemt passord</h1>
            <h1 v-else>Logg inn</h1>

            <div v-if="forgotPasswordMode" class="pt-4">
                Skriv inn brukernavnet og e-post adressen du er registrert med hos oss. Du vil motta en e-post med instruksjoner om hvordan du resetter ditt passord.
            </div>
            <div v-else-if="resetPasswordMode" class="pt-4">
                Lag et nytt passord her. Skriv inn passordet 2 ganger. Passordet må ha minst {{ minPasswdLength }} tegn.
            </div>
            <div v-else-if="otpMode" class="pt-4">
                <template v-if="otp.otpType === 'app'">
                    Skriv inn engangskode fra din OTP App
                </template>                
                <template v-else> <!-- SMS -->                    
                    Du mottar engangskode {{ otpMessage }}
                </template>
            </div>

            <form class="flex flex-col justify-center mt-4" @submit.prevent="doLogin()">        
                <div v-if="otpMode">
                    <InputField type="text" name="otp" v-model="otp.otpCode" image="/img/icon/password.svg" placeholder="Engangskode" autocomplete="one-time-code" inputmode="numeric" required />
                </div>
                <div v-else>
                    <InputField v-if="resetPasswordMode" type="password" v-model="password2" image="/img/icon/password.svg" placeholder="Nytt passord" required />
                    <InputField v-else type="text" v-model="username" image="/img/icon/name.svg" placeholder="Brukernavn" required />
                    <InputField v-if="forgotPasswordMode" type="email" v-model="email" image="/img/icon/email.svg" placeholder="E-postadresse" required />
                    <InputField v-else type="password" v-model="password" image="/img/icon/password.svg" :placeholder="resetPasswordMode ? 'Gjenta passord' : 'Passord'" :required="resetPasswordMode" />
                    <div v-if="!resetPasswordMode" class="text-right text-base">                    
                        <a href="#" @click.prevent="toggleForgotPasswordMode()">{{ forgotPasswordMode ? 'Logg inn' : 'Glemt passord?' }}</a>
                    </div>                
                </div>
                <button class="btn btn-blue mt-6" :disabled="loginInProgress">{{ forgotPasswordMode || resetPasswordMode ? 'Resett passord' : 'Logg inn' }}</button>
                <input type="hidden" name="origin" :value="appRoot">           
            </form>

            <div v-if="!resetPasswordMode" class="text-right mt-3">
                <div @click="toggleGoogleBtn" class="cursor-pointer text-sm mb-1 underline">Alternativ innlogging</div>
                <div class="float-right" :class="showGoogleBtn ? 'visible' : 'hidden'">
                    <div id="g_id_onload"
                        data-client_id="214751689930-b2vqr79mig4h09ukgrek0th9sjlhhle3.apps.googleusercontent.com"
                        data-login_uri-dev="http://localhost:8088/SMS/Login"
                        data-login_uri="https://sveve.no/SMS/Login"
                        data-auto_prompt="false"
                    >
                    </div>
                    <div class="g_id_signin"
                        data-type="standard"
                        data-size="large"
                        data-theme="outline"
                        data-text="sign_in_with"
                        data-shape="rectangular" 
                        data-logo_alignment="left">
                    </div>  
                    <div class="float-right text-xs">Bare for kunder med spesialavtale</div>                       
                </div>
            </div>                 
        </div>
    </div>
    
</template>

<script>
import InputField from '@/components/InputField.vue';
import { Settings } from '@/main.js';
import axios from 'axios';


export default {
    components: {
        InputField
    },
    computed: {
        otpMessage() {
            const otpNum = this.otp.otpNumber;
            if (otpNum) {
                return 'til ' + otpNum.substring(0, 2) + '****' + otpNum.substring(6, otpNum.length);            
            }
            return 'på SMS';
        }
    },
    data() {
        return {                   
            forgotPasswordMode: false,
            resetPasswordMode: false,
            otpMode: false,
            username: '',
            password: '',
            password2: '',
            resetKey: '',
            email: '',
            otp: {
                otpCode: '',
            },
            minPasswdLength: 8,
            showGoogleBtn: true,  // must be visible on init
            appRoot: '',
            errorMsg: '',
            successMsg: '',

            // -------- Texts -----------------
            leftHeading: 'Velkommen!',
            leftSubText: 'Velkommen tilbake til Sveve! Logg inn for å sende SMS og administrere din konto',
            leftHeading2: 'Hvorfor Sveve?',
            leftTicks: [
                'Brukervennlig og enkel',
                'Effektiv kommunikasjon',
                'Norsk kvalitetsleverandør'
            ],       
            loginInProgress: false,                 
        }
    },    
    created() {
        if (document.location.href.includes('//www.')) {   // this will cause the refresh token cookie to fail... (different domains)
            document.location.href = Settings.app.root + '/login';     
        }
    },
    mounted() {       
        this.appRoot = Settings.app.root + '/login';
        this.checkParams();
        
        let externalScript = document.createElement('script');
        externalScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
        document.head.appendChild(externalScript);
        externalScript.onload = () => {
            this.showGoogleBtn = false;
        };        
    },
    methods: {
        checkParams: function() {
            let q = (this.$route.query);  // get url query parameter 
            if ('e' in q && q.e === 'g') {
                this.errorMsg = 'Din Google-konto er ikke godkjent for innlogging hos Sveve';
            }
            else if ('resetkey' in q) {  // user has clicked on reset password link from email
                const auth = {
                    resetkey: q.resetkey
                };
                this.doLogin(auth);
            }
            else if ('code' in q) {  // callback from Microsoft auth (v2)
                const auth = {
                    code: q.code,
                    username: q.username,
                };
                this.doLogin(auth);
            }
            else if ('gauth' in q) {            
                const auth = {
                    googleCredential: q.gauth,
                };
                this.doLogin(auth);
            }
            else {
                let refreshToken = this.$cookies.get('refresh_token');
                if (refreshToken) {                
                    window.location.href = Settings.server.sms_app;   // try auto-login
                } 
            }
        },
        doLogin: function(authDataOverride) {             
            let authData = this.otpMode ? this.otp :
            {
                username: this.username,
                password: this.password,
            };
            if (authDataOverride) {
                authData = authDataOverride;
            }
            else if (this.forgotPasswordMode) {
                authData.email = this.email;                    
            }
            else if (this.resetPasswordMode) {
                this.errorMsg = '';
                this.password = this.password.trim();
                this.password2 = this.password2.trim();
                const passwdEqual = this.password === this.password2;
                const passwdLengthOk = Math.min(this.password.length, this.password2.length) >= this.minPasswdLength;
                if (!passwdEqual || !passwdLengthOk) {
                    const errMsg = [];
                    if (!passwdLengthOk) {
                        errMsg.push('Passordet må ha minst ' + this.minPasswdLength + ' tegn');
                    }
                    if (!passwdEqual) {
                        errMsg.push('Skriv passord inn likt 2 ganger');
                    }
                    this.errorMsg = errMsg.join('<br>');
                    return;
                }
                authData.setNewPassword = true;
                authData.resetkey = this.resetKey;
            }
            this.errorMsg = '';
            this.loginInProgress = true;
            axios.post(Settings.server.api + '/auth', authData, { headers: { 'X-Auth': 'gHuf-Ud74RtmsW-QQj-2' }})
                .then(res => {   
                    this.debugLogToServer(res.data);
                    if (res.data.forgotPassword) {
                        this.successMsg = res.data.forgotPassword;
                        this.username = '';
                        this.email = '';
                    }
                    else if (res.data.resetkey) {                            
                        this.resetKey = res.data.resetkey;
                        this.resetPasswordMode = true;
                    }
                    else if (res.data.passwordReset) {  // reset password ok
                        this.resetPasswordMode = false;
                        this.errorMsg = '';
                        this.password = '';
                        this.successMsg = 'Ditt passord er resatt';
                    }
                    else if (res.data.msLoginUrl) {  // Microsoft login redirect url
                        window.location.href = res.data.msLoginUrl;
                    }                  
                    else if (res.data.otp) {  // OTP required
                        this.otp = res.data;
                        this.otpMode = true;
                    }
                    else if (res.data.refresh_token) {
                        this.$cookies.set('refresh_token', res.data.refresh_token, res.data.expire);                                                                                                
                        window.location.href = Settings.server.sms_app;   // redirect to sms webapp                          
                    }

                    this.loginInProgress = false;
                })
                .catch (error => {
                    console.log(error.response);
                    this.debugLogToServer(error.response);
                    if (error.response.data) {
                        this.errorMsg  = error.response.data;
                        this.otpMode = false;
                    }
                    this.loginInProgress = false;
                }
            );

        },
        debugLogToServer: function(/*res*/)  {            
            /*const data = {
                username: this.username,
                data: JSON.stringify(res),
            }
            axios.post(Settings.server.api + '/debug/auth', data);*/
        },
        toggleForgotPasswordMode: function() {            
            this.forgotPasswordMode = !this.forgotPasswordMode;
            this.errorMsg = '';
            this.successMsg = '';
        },
        toggleGoogleBtn: function() {
            this.showGoogleBtn = !this.showGoogleBtn;
        },
    }
    
}
</script>